(function () {
  'use strict';

  angular.module('ringbaPortal').component('readMoreBox', {
    bindings: {
      text: '<'
    },
    controller: ReadMoreBoxController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/read-more-box/read-more-box.view.html'
  });

  function ReadMoreBoxController(

  ) {
    'ngInject';

    const vm = this;
    const numberOfLines = 5;
    const numberOfChars = 200;
    const ellipsis = '......';

    vm.$onChanges = onChanges;

    function onChanges() {
      if (vm.text) {
        _showFinalText(vm.text);
      } else {
        vm.showReadMore = false;
        vm.overviewText = undefined;
      }
    }

    function _showFinalText(text) {
      vm.showReadMore = false;
      const lines = text.split('\n').length;
      if (text.length > numberOfChars) {
        vm.showReadMore = true;
        vm.overviewText = text.slice(0, numberOfChars) + ellipsis;
      } else if (lines > numberOfLines) {
        vm.showReadMore = true;
        vm.overviewText = text.split('\n').slice(0, numberOfLines).join('\n') + ellipsis;
      }
    }


  }
})();
